module.exports = __webpack_public_path__ + "img/hr-document.78f7e506.jpg";